/**
 * Task-related constants
 */
export const TASK_PAGE_SIZE = 20;

